import {
    AfterContentInit,
    Component,
    contentChildren,
    forwardRef,
    CUSTOM_ELEMENTS_SCHEMA,
    effect
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ShRadioCardItemComponent } from './sh-radio-card-item.component';

@Component({
    selector: 'sh-radio-card',
    standalone: true,
    templateUrl: './sh-radio-card.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ShRadioCardComponent),
            multi: true
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShRadioCardComponent implements ControlValueAccessor, AfterContentInit {
    private items = contentChildren(ShRadioCardItemComponent);
    private currentValue: string | null = null;
    private onChange: (value: string | null) => void = () => {};
    private onTouched: () => void = () => {};

    constructor() {
        effect(() => {
            this.setupItems(this.items());
        });
    }

    public ngAfterContentInit(): void {
        this.setupItems(this.items());
    }

    public writeValue(value: string | null): void {
        this.currentValue = value;
        this.updateSelection();
    }

    public registerOnChange(fn: (value: string | null) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    private setupItems(items: readonly ShRadioCardItemComponent[]): void {
        items.forEach((item) => {
            item.onSelect = () => this.selectItem(item);
        });
        this.updateSelection();
    }

    private selectItem(item: ShRadioCardItemComponent): void {
        this.currentValue = item.value();
        this.onChange(this.currentValue);
        this.onTouched();
        this.updateSelection();
    }

    private updateSelection(): void {
        const items = this.items();
        if (!items.length) return;
        if (this.currentValue === null) {
            items.forEach((item) => {
                item.selected = false;
                item.dimmed = false;
            });
            return;
        }
        items.forEach((item) => {
            const isSelected = item.value() === this.currentValue;
            item.selected = isSelected;
            item.dimmed = !isSelected;
        });
    }
}
